(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-row-list"] && !Shopify.designMode) return;
  try {
    
  // const width = window.screen.width
  // if(width<=640) {
  //   const pcDevice = document.querySelector('.col-pc-device');
  //   pcDevice.remove();
  // }else{
  //   const mobileDevice = document.querySelector('.col-mobile-device');
  //   mobileDevice.remove();
  // }
  setTimeout(() => {
    const sectionIds = document.querySelectorAll(".col-section-id")


    if(sectionIds && sectionIds.length > 0) {
      sectionIds.forEach(sectionIdEl => {
        const sectionId = sectionIdEl.innerText;
        console.log('sectionId', sectionId)
        const slider = document.querySelector(".col-js-slider."+sectionId)
        const pcSlider = document.querySelector(".col-js-pc-slider."+sectionId)
        const mobileSlider = document.querySelector(".col-js-mobile-slider."+sectionId)
        // 手机端
        if (mobileSlider) {
          const autoPlay = pcSlider.getAttribute('data-autoplay-mobile')
          const autoPlayTime = mobileSlider.getAttribute('data-autoplay-time')
          const mySwiper = new Swiper('.col-js-mobile-slider.'+sectionId, {
              loop:true,
              autoplay: autoPlay === 'true' ? {
                 delay: autoPlayTime*1000,
              } : false,
              pagination: {
                 el: '.swiper-pagination',
                 clickable: true
              },
              navigation: {
                 nextEl: '.col-swiper-button-next.'+sectionId,
                 prevEl: '.col-swiper-button-prev.'+sectionId,
              },
           })
        }
        // PC端
        if (pcSlider) {
          const slidesPerView = pcSlider.getAttribute('data-slides-per-view')
          const spaceBetween = pcSlider.getAttribute('data-space-between')
          const autoPlay = pcSlider.getAttribute('data-autoplay')
          const autoPlayTime = pcSlider.getAttribute('data-autoplay-time')
          console.log('sectionId autoPlay', autoPlay, autoPlayTime)

          const mySwiper = new Swiper('.col-js-pc-slider.'+sectionId, {
            loop:true,
            autoplay: autoPlay === 'true' ? {
              delay: autoPlayTime*1000
            } : false,
            slidesPerView,
            spaceBetween,
            pagination: {
               el: '.col-swiper-pagination',
               clickable: true,
               renderBullet: function (index, className) {
                  return '<span class="' + className + '">&nbsp;' + '</span>';
               }
            },
            navigation: {
               nextEl: '.col-swiper-button-next.'+sectionId,
               prevEl: '.col-swiper-button-prev.'+sectionId,
            },
          });
        }
      })
    }



    console.log('collections-row-list.liquid loaded')
  }, 100)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  // const width = window.screen.width
  // if(width<=640) {
  //   const pcDevice = document.querySelector('.img-pc-device');
  //   pcDevice.remove();
  // }else{
  //   const mobileDevice = document.querySelector('.img-mobile-device');
  //   mobileDevice.remove();
  // }
  setTimeout(() => {

    const slider = document.querySelector('.img-js-slider')
    const mobileSlider = document.querySelector('.img-js-mobile-slider')
    const pcSlider = document.querySelector('.img-js-pc-slider')


    // 手机端
    if (mobileSlider) {
      const autoPlayTime = mobileSlider.getAttribute('data-autoplay-time')
      const mySwiper = new Swiper('.img-js-mobile-slider', {
          loop:true,
          autoplay: {
             delay: autoPlayTime*1000,
          },
          pagination: {
             el: '.img-swiper-pagination',
             clickable: true,
             renderBullet: function (index, className) {
                return '<span class="' + className + '">&nbsp;' + '</span>';
             }
          },
          navigation: {
             nextEl: '.img-swiper-button-next',
             prevEl: '.img-swiper-button-prev',
          },
       })
    }
    // PC端
    if (pcSlider) {
      const autoPlayTime = pcSlider.getAttribute('data-autoplay-time')
      const mySwiper = new Swiper('.img-js-pc-slider', {
          loop:true,
          autoplay: {
             delay: autoPlayTime*1000,
          },
          pagination: {
             el: '.img-swiper-pagination',
             clickable: true,
             renderBullet: function (index, className) {
                return '<span class="' + className + '">&nbsp;' + '</span>';
             }
          },
          navigation: {
             nextEl: '.img-swiper-button-next',
             prevEl: '.img-swiper-button-prev',
          },
       })
    }
    console.log('image-banner.liquid loaded')
  }, 100)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider-swiper"] && !Shopify.designMode) return;
  try {
    
  // const width = window.screen.width
  // if(width<=640) {
  //   const pcDevice = document.querySelector('.pb-pc-device');
  //   pcDevice.remove();
  // }else{
  //   const mobileDevice = document.querySelector('.pb-mobile-device');
  //   mobileDevice.remove();
  // }

  const slider = document.querySelector('.js-slider')

  if (slider) {
     const loop = slider.getAttribute('data-autorotate') === 'true'
     const delay = slider.getAttribute('data-speed')

     const mySwiper = new Swiper('.js-slider', {
        loop,
        autoplay: {
           delay,
        },
        pagination: {
           el: '.swiper-pagination',
           clickable: true
        },
        navigation: {
           nextEl: '.swiper-button-next',
           prevEl: '.swiper-button-prev',
        },
     })
  }

  } catch(e) { console.error(e); }
})();
})();
